import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { customStyles } from '../../helper';

export function SpacerSetting({ obj, handleSpacerStyle }) {
  const { t } = useTranslation('common');
  const spacerSizeOptions = [
    { label: '5', value: '5px' },
    { label: '10', value: '10px' },
    { label: '15', value: '15px' },
    { label: '20', value: '20px' },
    { label: '25', value: '25px' },
  ];

  return (
    <div className="common-react-select">
      <p className="field-name">
        {t('DPP.CONTROL.SPACER.SIZE')}
        <span className="asterisk">*</span>
      </p>
      <Select
        placeholder={t('DPP.CONTROL.SPACER.SELECT_SPACER_SIZE')}
        options={spacerSizeOptions}
        styles={customStyles}
        className="common-select"
        classNamePrefix="common-select"
        getOptionLabel={({ label }) => `${label}`}
        getOptionValue={({ value }) => `${value}`}
        value={obj?.spacerHeight || spacerSizeOptions[0]} // Fallback to default
        onChange={(selected) => handleSpacerStyle(selected)}
        defaultValue={spacerSizeOptions[0]} // Set default value
      />
    </div>
  );
}

export default SpacerSetting;
